
export enum headType {
    none = 'none',
    H_C_S1S2 = 'H-C-S1S2',
    H_2C_S1S2 = 'H-2C-S1S2',
    H_2C_XL = 'H-2C-XL',
}